import { useEffect, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import FormBuilder from "../../plugins/formBuilder/formBuilder";
import MuiTabsForm from "../../plugins/components/Mui/Tabs";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { FormDataProvider } from "../../context/FormDataContext";
import TabLoading from "../../Loaders/tabsLoading";
import PageMeta from "../../components/common/PageMeta";

const VehicleForm = () => {
  const [tabsRes, setTabsRes] = useState([]);
  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/formtabs",
  });

  useEffect(() => {
    mutate({ formtabid: "driverPage" });
  }, []);

  useEffect(() => {
    if (res) {
      setTabsRes(res?.data?.formtabs);
    }
  }, [res]);

  if (isPending) {
    return <TabLoading />;
  }

  return (
    <>
      <PageMeta title="TTM Add Driver | Admin Driver" description="" />
      <PageBreadcrumb pageTitle="Add Driver" />
      <MuiTabsForm tabsRes={tabsRes} />
    </>
  );
};

export default VehicleForm;
